import { Observable } from 'rxjs/Observable';
import { Component, OnInit, OnChanges, ViewContainerRef, Input, ElementRef, ChangeDetectorRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';

import { AddServiceComponent } from 'app/entities/details/services/addservices/add-service.component';
import { EditServicesDescriptionComponent } from 'app/entities/details/services/editdescription/edit-description.component';

import { ClientHeaderService } from 'app/clients/client/header/client-header.service';
import { ClientServicesService } from 'app/entities/details/services/client-services.service';

import { ConfirmationDialogComponent } from 'app/shared/components/confirmationdialog/confirmation-dialog.component';
import { OrganisationDetails } from 'app/shared/models/org-details.model';

import { Document } from 'app/shared/models/document.model';
import { ClientService, ServiceValue } from 'app/entities/details/services/client-service.model';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { WarmUpService } from 'app/services/warmup/warmup.service';
import { ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ConstantsService } from 'app/services/constants-service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { AddDocumentComponent } from 'app/shared/components/adddocument/add-document.component';

@Component({
    selector: 'client-services',
    templateUrl: './client-services.component.html'
})

export class ClientServicesComponent implements OnChanges {
    @Input() entityIdDetails: EntityIdDetails;
    selectedServices: Array<ServiceValue> = [];
    dialogRef: MdDialogRef<any>;
    documentsDescription: string;
    documentTypes: ApplicationValue[];
    serviceDocuments: Array<Document>;
    outsourcingDocuments: Array<Document>;
    serviceAgreement = 'Service Agreement';
    outsourcingAgreement = 'Outsourcing Agreement';

    constructor(
        public dialog: MdDialog,
        private clientHeaderService: ClientHeaderService,
        private viewContainerRef: ViewContainerRef,
        private clientServicesService: ClientServicesService,
        private snackBarService: SnackBarService,
        private warmUpService: WarmUpService,
        private cdr: ChangeDetectorRef) { }

    ngOnChanges() {
        this.serviceDocuments = new Array<Document>();
        this.outsourcingDocuments = new Array<Document>();
        this.setupControlValues(this.warmUpService.getApplicationValue(ApplicationTypeConstants.DOCUMENT_TYPE));
        this.clientServicesService.fetchClientServices(this.entityIdDetails.orgId).subscribe(
            response => {
                this.selectedServices = response.arrResult;
            }
        );
        this.clientServicesService.fetchDocumentsDescription(this.entityIdDetails.clientId).subscribe(
            response => {
                this.documentsDescription = response.arrResult;
            }
        );
        this.clientServicesService.fetchDocumentsByDocType(
            this.entityIdDetails.entityId, this.fetchDocumentTypeName(this.serviceAgreement)).subscribe(
            response => {
                this.serviceDocuments = response.arrResult;
            });
        this.clientServicesService.fetchDocumentsByDocType(
            this.entityIdDetails.entityId, this.fetchDocumentTypeName(this.outsourcingAgreement)).subscribe(
            response => {
                this.outsourcingDocuments = response.arrResult;
            });
    }

    setupControlValues(dropDownValues: any) {
        if (dropDownValues instanceof Observable) {
            dropDownValues.subscribe(
                response => {
                    this.warmUpService.setApplicationTypeInLS(response);
                    this.documentTypes = response.values;
                    this.cdr.detectChanges();
                }
            );
        } else {
            this.documentTypes = dropDownValues;
        }
    }

    fetchDocumentTypeName(docTypeName: string): number {
        if (this.documentTypes) {
            const docType = this.documentTypes.find(documentType => documentType.name === docTypeName);
            return docType ? docType.id : 0;
        }
        return 0;
    }

    openAddServiceDialog() {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(AddServiceComponent, config);
        this.dialogRef.componentInstance.clientId = this.entityIdDetails.clientId;
        this.dialogRef.componentInstance.addedServices = this.selectedServices;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                this.selectedServices = result;
            }
        });
    }

    openEditDescriptionDialog(isServicesDescription: boolean, serviceValue: ServiceValue) {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(EditServicesDescriptionComponent, config);
        this.dialogRef.componentInstance.clientId = this.entityIdDetails.clientId;
        this.dialogRef.componentInstance.isServicesDescription = isServicesDescription;
        if (isServicesDescription) {
            this.dialogRef.componentInstance.description = serviceValue.description;
            this.dialogRef.componentInstance.serviceId = serviceValue.id;
        } else {
            this.dialogRef.componentInstance.description = this.documentsDescription;
        }
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                if (!isServicesDescription) {
                    this.documentsDescription = result;
                } else {
                    this.ngOnChanges();
                }
            }
        });
    }

    openAddServiceAgreementDialog() {
        this.openAddDocumentDialog(null, this.serviceAgreement);
    }

    openAddOutsourcingAgreementDialog() {
        this.openAddDocumentDialog(null, this.outsourcingAgreement);
    }

    openAddDocumentDialog(document: Document, documentType: string) {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(AddDocumentComponent, config);
        this.dialogRef.componentInstance.action = document && 'Edit' || 'Add';
        this.dialogRef.componentInstance.selectedDocumentType = documentType;
        this.dialogRef.componentInstance.selectedDocument = document;
        this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
        this.dialogRef.componentInstance.isServiceDetailsAgrement = documentType === this.serviceAgreement;
        this.dialogRef.componentInstance.isOutsourcingDetailsAgreement = documentType === this.outsourcingAgreement;
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.ngOnChanges();
            }
        });
    }

    deleteDocumentDialog(document) {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(ConfirmationDialogComponent, config);
        this.dialogRef.componentInstance.message = 'Are you sure you want to delete this document?';
        this.dialogRef.componentInstance.title = 'Delete Document';
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.deleteDocument(document);
            }
        });
    }

    deleteDocument(document: Document): void {
        this.clientServicesService.deleteDocument(document.id)
            .subscribe(response => {
                this.ngOnChanges();
                this.callSnackBarService(response, MessageService.DELETE_DOCUMENT_SUCCESS);
            }, err => {
                this.callSnackBarService(err, '');
            });
    }

    callSnackBarService(response: any, successMsg) {
        this.snackBarService
            .showStatus(response, successMsg, MessageService.DOCUMENT_FAILURE);
    }

    updateDoucment(documents: Array<Document>) {
        documents.forEach(document => {
            for (const index in this.serviceDocuments) {
                if (this.serviceDocuments[index]['id'] === document.id) {
                    this.serviceDocuments[index] = document;
                }
            }
        });
    }

    downloadDocument(id: number) {
      window.open(ConstantsService.APP_BE_URL +'/'+ ConstantsService.DOWNLOAD_DOCUMENT + '?documentId=' + id);
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/services/client-services.component.ts